<template>
    <div class='sidebar-container' :class="{'small' : !menu_expanded}">
        <div class='control-panel-title' :class="{'small' : !menu_expanded}">
            <div class='icon'><i class="fa-solid fa-sliders"></i></div> <span v-show="menu_expanded">Control Panel</span> 
            <!-- <span @click='toggleSideBar'>
                <span v-show='menu_expanded'><i class="fa-light fa-chevron-left"></i></span>
                <span v-show='!menu_expanded'><i class="fa-light fa-chevron-right"></i></span>
            </span> -->
        </div>

        <div class='sidebar-content'>
            <div class='menu-items-section'>
                <div v-for="item in menu_items" :key="item.id">
                    <AdminSideBarItem :expanded='menu_expanded' :id='item.id' :selected='item.selected' :text='item.text' :icon='item.icon' @click='goToPage(item.id)' />
                </div>
            </div>
            <div class='bottom-section'>
                <AdminSideBarItem :expanded='menu_expanded' id='logout' :selected='false' text='Logout' icon='fa-solid fa-right-from-bracket' @click='logout()' />
            </div>
        </div>
    </div>
</template>

<script>
import {checkAuth} from "@/global/modules/functions.js";
import AdminSideBarItem from '@/ecom_cms/components/navigation/AdminSideBarItem.vue';

export default {
    components: {AdminSideBarItem},
    props: ['page_name', 'menu_expanded'],
    emits: ['selectedMenuOptionListener'],
    data(){
        return{
            selected: '',
            menu_items: [
                {id: 'page_builder_dashboard', text: 'Page Builder', icon: 'fa-solid fa-objects-column', selected: true},
                {id: 'mobile_builder', text: 'Mobile Builder', icon: 'fa-solid fa-mobile', selected: false},
                {id: 'products', text: 'Products', icon: 'fa-solid fa-shopping-bag', selected: false},
                {id: 'categories', text: 'Categories', icon: 'fa-solid fa-list', selected: false},
                {id: 'analytics', text: 'Analytics', icon: 'fa-solid fa-chart-line-up', selected: false},
                {id: 'product_types', text: 'Product Types', icon: 'fa-brands fa-product-hunt', selected: false},
                {id: 'users', text: 'Users', icon: 'fa-solid fa-users', selected: false},
                {id: 'campaigns', text: 'Campaigns', icon: 'fa-solid fa-wine-glass', selected: false},
                {id: 'config', text: 'Config', icon: 'fa-solid fa-sliders', selected: false},
            ],
            title: ''
        }
    },
    methods:{
        goToPage(page){
            this.selectedMenu(page);
            this.$router.push(`/admin/${page}`);
            this.$emit('selectedMenuOptionListener', this.title);
        },
        selectedMenu(page) {
            if(this.menu_items.filter(x=>x.id == page).length != 0){
                this.menu_items.filter(x=>x.selected == true)[0].selected = false;
                this.menu_items.filter(x=>x.id == page)[0].selected = true;
            }
        },
        async logout(){
            let response = await fetch(`/api/admin/logout`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({}),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
               window.open('/admin/login', "_self");
            }
        },
        setTitle(page) {
            switch(page){
                case 'Admin Products':
                    this.title = 'Products'
                    break;
                case 'Admin Categories':
                    this.title = 'Categories'
                    break;
                case 'Admin Analytics':
                    this.title = 'Analytics'
                    break;
                case 'Admin Product Types':
                    this.title = 'Product Types'
                    break;
                case 'Admin Users':
                    this.title = 'Users'
                    break;
                case 'Admin Campaigns':
                    this.title = 'Campaigns'
                    break;
                default:
                    this.title = page;
                    break;    
            }
        },
        getTitle(page) {
            this.setTitle(page);
            this.$emit('selectedMenuOptionListener', this.title);
        },
        toggleSideBar(){
            this.menu_expanded = !this.menu_expanded;
        }
    },
    beforeMount() {
        let current_route = window.location.pathname;
        let section = current_route.split('/admin/')[1].split('?')[0];
        this.selectedMenu(section);
                  this.getTitle(this.page_name);
    },
    watch: {
        'page_name': function() {
          this.getTitle(this.page_name);
        }
    }
}

</script>

<style scoped lang='scss'>
.sidebar-container{
    background-color: white;
    position: sticky;
    // position: fixed;
    top: 0;
    height: 100dvh;
    // height: 100%;
    width: 260px;
    min-width: 260px;
    padding: 20px 20px;
    box-sizing: border-box;
    -webkit-transition: width 0.3s ease-in-out;
    -moz-transition: width 0.3s ease-in-out;
    -o-transition: width 0.3s ease-in-out;
    transition: width 0.3s ease-in-out;
}

.sidebar-container.small{
    width: 100px;
     min-width: 100px;
    -webkit-transition: width 0.3s ease-in-out;
    -moz-transition: width 0.3s ease-in-out;
    -o-transition: width 0.3s ease-in-out;
    transition: width 0.3s ease-in-out;
}

.sidebar-content{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.menu-items-section{
    margin-top: 40px;
    flex-grow: 1;
}

.bottom-section{
    height: 100px;
}

.control-panel-title{
    display: flex;
    gap: 10px;
    align-items: center;
    font-size: 1.4rem;
    // text-align: center;
}

.control-panel-title.small{
    justify-content: center;
}

.icon{
    color: var(--primary-colour);
}
</style>